module.exports = __webpack_public_path__ + "static/media/mongodb.c81f0054.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poweredby/mongodb.png
// module id = 140
// module chunks = 0